import {
  getTimeOffCalendarPeriods,
  TimeOffCalendarPeriodModel,
  TimeOffCalendarPeriodType,
} from "@/types/time-off/time-off.types.ts";
import { Button, DropdownMenu, DropdownMenuItem, FontAwesomeIcon } from "@skailer-com/uikit";

interface TimeOffCalendarPeriodProps {
  chosenPeriod: TimeOffCalendarPeriodType;
  onChange: (type: TimeOffCalendarPeriodModel) => void;
}

export function TimeOffCalendarPeriod({ chosenPeriod, onChange }: TimeOffCalendarPeriodProps) {
  const chosenPeriodTitle = getTimeOffCalendarPeriods().find(
    (period) => period.type == chosenPeriod
  )!.title;

  return (
    <DropdownMenu
      trigger={
        <Button
          variant={"secondary"}
          rightIcon={<FontAwesomeIcon icon={"fa-light fa-chevron-down shrink-0"} />}
        >
          {chosenPeriodTitle}
        </Button>
      }
    >
      {getTimeOffCalendarPeriods().map((period) => (
        <DropdownMenuItem
          key={`period_${period.type}`}
          title={period.title}
          isSelected={period.type === chosenPeriod}
          onClick={() => onChange(period)}
        />
      ))}
    </DropdownMenu>
  );
}
